import { render, staticRenderFns } from "./paycools-index.vue?vue&type=template&id=6cb38363&scoped=true"
import script from "./paycools-index.vue?vue&type=script&lang=js"
export * from "./paycools-index.vue?vue&type=script&lang=js"
import style0 from "./paycools-index.vue?vue&type=style&index=0&id=6cb38363&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb38363",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cb38363')) {
      api.createRecord('6cb38363', component.options)
    } else {
      api.reload('6cb38363', component.options)
    }
    module.hot.accept("./paycools-index.vue?vue&type=template&id=6cb38363&scoped=true", function () {
      api.rerender('6cb38363', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/paycools-index.vue"
export default component.exports